import {ICcValorDistribuivelFilter} from "@models/contaContabil/Filters/ICcValorDistribuivelFilter.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {__contacontabil_endpoints} from "@components/contaContabil/endpoints/__contacontabil_endpoints.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

export function useCcDistribuibuivel() {
    const {Get} = useApi()

    const getCcsValoresDistribuiveis = (v: ICcValorDistribuivelFilter, p: IPagination) => {
        return Get(__contacontabil_endpoints.GetContasContabeisValoresDistribuiveis(v, p))
    }

    const getCcValorDistribuivelById = (id: number) => {
        return Get(__contacontabil_endpoints.GetContasContabeisValoresDistribuiveis({id: [id]}, {
            page: 1,
            pageSize: 1
        })).then(x => x.items[0])
    }
    const getCcValorDistribuivelByCc = (id: number, p: IPagination = {page: 1, pageSize: 10}) => {
        return Get(__contacontabil_endpoints.GetContasContabeisValoresDistribuiveis({contaContabilId: [id]}, p))
    }

    return ({getCcsValoresDistribuiveis, getCcValorDistribuivelById, getCcValorDistribuivelByCc})
}